/**
 Validates org numbers from Germany, e.g. HRB 8536
 */
export const validateGermanyOrgNumber = (number: string) => {
  const germanyOrgNumberRegex =
    /^((G([nN])R)|(HRA)|(HRB)|(PR)|(VR))\s?\d{1,6}\s?[A-Z]{0,5}(-[A-Z]\d{4})?$/g;

  return germanyOrgNumberRegex.test(number);
};
